export default {
  REGISTER_CLICKED: "initiate_signup",
  REGISTER_SUCCESSFUL: "register_successful",
  REGISTER_FAILED: "register_failed",
  REGISTER_ABORTED: "register_rejected",
  LOGIN_CLICKED: "login_clicked",
  LOGIN_SUCCESSFUL: "login_successful",
  LOGIN_FAILED: "login_failed",
  ADWORDS: "Adwords",
  SEPHORAADWORDS: "sephoraAdwords",
  LISTING: "ListingPage",
  CATEGORY_SELECTED: "category_viewed",
  ECOMM_LISTING: "category",
  PRODUCT: "product",
  PRODUCT_VIEW: "view",
  GTM_CURRENCY: "INR",
  PLACE_ORDER: "place_order",
  PRODUCT_WISHLIST: "shortlist",
  LOGIN: "signin",
  REGISTER: "signup",
  LOGOUT: "logout",
  EMAIL_SUBSCRIBE: "email_subscribe",
  ADD_PRODUCT: "add_to_cart",
  REMOVE_PRODUCT: "remove_from_cart",
  USER_ATTRIBUTES: "user_attr",
  PROMO_SUCCESS: "coupon_success",
  PROMO_FAILURE: "coupon_failed",
  CHECKOUT_SHIPPING: "checkout_shipping",
  CHECKOUT_PAYMENT: "checkout_payment",
  MYBAG_LANDED: "mybag",
  CONVERSION: "purchase",
  SEPHORA_CONVERSION: "sephoraAdwordsConversion",
  CANCEL_INITATED: "cancel_initiated",
  CANCEL_COMPLETE: "cancel_completed",
  RETURN_INITATED: "return_initiated",
  RETURN_COMPLETE: "return_conmpleted",

};



// WEBPACK FOOTER //
// ./src/analytics/eventFactory/GTMEvents.js